import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ContractListDataService extends DataService<typeof Model.Products.Logic.ViewModels.ContractSummary, Model.Products.Logic.ViewModels.ContractSummary, ContractSummary> {
    protected map(entity: Model.Products.Logic.ViewModels.ContractSummary): ContractSummary {
        return new ContractSummaryModel(entity);
    }

    public static make(ctx?: any): ContractListDataService {
        return new ContractListDataService(ctx, ctx => ctx.ContractSummaries);
    }
}

export class ContractSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.ContractSummary, ContractSummary> implements ContractSummary {

    @property<ContractSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<ContractSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<ContractSummaryModel>(o => o.entity.productId, (o, value) => o.entity.productId = value)
    public productId: number;

    @property<ContractSummaryModel>(o => o.entity.supplierId, (o, value) => o.entity.supplierId = value)
    public supplierId: number;
}



// WEBPACK FOOTER //
// ./src/app/products/contract/list/contract-list.data.ts